import { render, staticRenderFns } from "./classSec.vue?vue&type=template&id=97c78cf0&scoped=true&"
import script from "./classSec.vue?vue&type=script&lang=js&"
export * from "./classSec.vue?vue&type=script&lang=js&"
import style0 from "./classSec.vue?vue&type=style&index=0&id=97c78cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c78cf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
